


import { HeaderNav } from "./header-nav/header-nav";

import "./header.css"

export const Header = ({props}) => {

   

    return (
        <header className="position-relative"> 
            <HeaderNav props={props}/>
        </header>
    )
}